import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map, startWith } from "rxjs/operators";

// Models
import { ContextLocationViewModel } from "src/app/_core/models/main/context-location.model";
import { LinkItem } from "src/app/_core/models/main/link-item.model";
import { PlaceViewModel } from "src/app/_core/models/main/place.model";
import { UserProfileViewModel } from "src/app/_core/models/main/user-profile.model";

// Services
//import { SnackBarService } from './../../globalServices/snackBar.service';
import { TranslateService } from "@ngx-translate/core";
import { FavPageViewModel } from "src/app/_core/models/home/fav-page.model";
import { AuthService } from "src/app/_core/providers/auth.service";
import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";

// Constants
import { HOME_MENU_ITEMS } from "src/app/_core/constants/menu.constants";
import { HeaderService } from "src/app/_core/providers/header.service";
import { UserProfileStore } from "src/app/_core/stores/user-profile.store";

// Material
import { MatDialog } from "@angular/material/dialog";

// Components
import { Policies } from "src/app/_core/models/main/policies.enum";
import { ApplicationViewModel } from "src/app/_core/models/master/application.model";
import { ConfirmDialogComponent } from "src/app/modules/main/components/dialogs/confirm-dialog/confirm-dialog.component";

@Component({
	selector: "app-header",
	templateUrl: "./header.component.html",
	styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
	@Input() favPage!: FavPageViewModel;
	@Output() unfavEvent = new EventEmitter<string>();
	@Output() toggleProfile: EventEmitter<any> = new EventEmitter();

	// Constructor
	constructor(
		private readonly _router: Router,
		private readonly _headerService: HeaderService,
		private readonly _authService: AuthService,
		private readonly _userProfileStore: UserProfileStore,
		private readonly _translateService: TranslateService,
		private readonly _global: GlobalService,
		public dialog: MatDialog
	) {
		//   _router.events.subscribe(value => {
		//     this.currentUrl = this._router.url.toString();
		//     this.refreshIsFav();
		// });

		_router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((_event: NavigationEnd) => {
				this.currentFilter = "";
				this.currentUrl = this._router.url.toString();
				this.refreshIsFav();
			});

		this.userProfile = this._userProfileStore.getUserProfile();
	}

	// Properties
	public migas: MigaDePan[] = [];
	public breadcrumbs: LinkItem[];
	public current: LinkItem;
	public HOME_MENU_ITEMS = HOME_MENU_ITEMS;
	public toolbar: ApplicationViewModel[];
	public stateCtrl = new FormControl();
	public filteredPlaces: Observable<PlaceViewModel[]>;
	public places: PlaceViewModel[];
	public sectors: PlaceViewModel[];
	public place: PlaceViewModel;
	public contextLocation: ContextLocationViewModel;
	public currentFilter: string;
	public userProfile: UserProfileViewModel;
	public isFavPage: boolean;
	public currentUrl: string;
	public favPageList: FavPageViewModel[];
	public displayDialog: boolean;
	public isMenuCollapsed = true;
	public darkMode = false;

	// Events
	ngOnInit() {
		this._global.migas$.subscribe((migas) => {
			this.migas = migas;
		});
		this.currentUrl = this._router.url.toString();
		this.getData();
		this._refillFromGlobal();

		this._global.changesDetected.subscribe((_result) => {
			this._refillFromGlobal();
		});
	}

	// Public methods
	onSearch(event: any) {
		this.currentFilter = event;
	}

	placeSelected(event: any) {
		try {
			this._router.navigate([event.option.value]).then(() => {
				window.location.reload();
			});
		} catch (error) {
			console.error("Navigation error:", error);
		}
	}

	refreshIsFav() {
		this.isFavPage = false;
		if (
			this.favPageList &&
			this.favPageList.length > 0 &&
			this.currentUrl
		) {
			const aux = this.favPageList.filter((x) =>
				x.url == null
					? ""
					: x.url.toLowerCase() == this.currentUrl.toLowerCase()
			);
			this.isFavPage = aux && aux.length > 0;
		}
	}

	savePageFav() {
		const auxName = this.HOME_MENU_ITEMS.filter(
			(x) =>
				x.url === this.currentUrl.replace(this.current?.url || "", "")
		);
		const stringName =
			auxName && auxName.length > 0
				? this._translateService.instant(auxName[0].text)
				: this._translateService.instant(
						"header.toolbar.favorites.dashboard"
				  );
		// Call the back-end
	}

	deletePageFav() {
		const auxName = this.HOME_MENU_ITEMS.filter(
			(x) =>
				x.url === this.currentUrl.replace(this.current?.url || "", "")
		);
		const stringName =
			auxName && auxName.length > 0
				? this._translateService.instant(auxName[0].text)
				: this._translateService.instant(
						"header.toolbar.favorites.dashboard"
				  );

		// Call the back-end
	}

	displayFn(place: PlaceViewModel): string {
		return place ? place.name : "";
	}

	emitProfile() {
		this.toggleProfile.emit(null);
	}

	openLogOutDialog() {
		const dialogRef = this.dialog.open<
			ConfirmDialogComponent,
			any,
			boolean
		>(ConfirmDialogComponent, {
			data: {
				messageText: "shared.confirmDialog.logoutMessage",
				showCancelButton: true,
			},
		});
		const subscribeDialog = dialogRef.componentInstance.onConfirm.subscribe(
			(data) => {
				if (data) {
					this._logOut();
				}
			}
		);
		dialogRef.afterClosed().subscribe((result) => {
			subscribeDialog.unsubscribe();
		});
	}

	collapseMenu() {
		this.isMenuCollapsed = true;
	}

	getData() {
		this._headerService.getPlaces().subscribe((result) => {
			//debugger;
			this.places = result.sort((a, b) => (a.name > b.name ? 1 : -1));
			this._calculateData();
			//this._setupPlants();
		});

		// Call back-end to get favs
	}

	hasAccess(link: LinkItem): boolean {
		const policies = link.policies;
		let result = false;

		if (!policies || (policies && policies.length == 0)) {
			result = true;
		} else {
			const userProfile = this._userProfileStore.getUserProfile();
			const userPolicies = userProfile.profiles.map((up) => up.profile);

			if (userPolicies.indexOf(Policies.Admin) > -1) {
				result = true;
			} else if (
				userProfile &&
				userProfile.profiles &&
				userProfile.profiles.length > 0
			) {
				const violatedPolicies = policies.filter(
					(p) => userPolicies.indexOf(p) == -1
				);
				result = violatedPolicies && violatedPolicies.length == 0;
			}
		}

		return result;
	}

	public enableBreadcrumbLink(link: LinkItem, isLast: boolean): boolean {
		return link.active === true && !isLast && this.hasAccess(link);
	}

	// Private methods
	// private _replaceAll(str, find, replace) {
	//     var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
	//     return str.replace(new RegExp(escapedFind, 'g'), replace);
	// }

	private _refillFromGlobal() {
		this.breadcrumbs = this._global.breadcrumbs;
		this.current = this._global.current;
		this.toolbar = this._global.toolbar;
		//this._setupPlants();
	}

	private _calculateData() {
		this.filteredPlaces = this.stateCtrl.valueChanges.pipe(
			startWith(""),
			map((state) =>
				state ? this._filterStates(state) : this.places.slice()
			)
		);
	}

	private _filterStates(value: string): PlaceViewModel[] {
		const filterValue = value.toLowerCase();
		return this.places.filter(
			(x) =>
				x.name.toLowerCase().indexOf(filterValue) >= 0 ||
				x.id?.toString().toLowerCase().indexOf(filterValue) >= 0 ||
				x.code?.toLowerCase().indexOf(filterValue) >= 0 ||
				x.typeNameTranslation.toLowerCase().indexOf(filterValue) >= 0
		);
	}

	/*   private _setupPlants() {
          this.contextLocation = this._global.lastPlace;
          let auxSectors = this.places ? this.places.filter(x => x.parentId && x.parentId.toLowerCase() == (this._global.lastPlace?.cebe?() ?? "NO BUSCAR")) : [];
          this.sectors = this._setupSectorsRecursive(auxSectors, null, 0)
      } */

	// private _setupSectorsRecursive(sectors: PlaceViewModel[], parent: string, level: number): PlaceViewModel[] {
	//     let result: PlaceViewModel[] = [];
	//     let auxSectors = sectors.filter(x => (!parent && !x.internalParentId) || (x.internalParentId && x.internalParentId.toLowerCase() == parent)).sort((x, y) => x.parentId > y.parentId ? 1 : -1);
	//     for (var auxSector of auxSectors) {
	//         auxSector.level = level;
	//         result.push(auxSector);
	//         result = result.concat(this._setupSectorsRecursive(sectors, auxSector.id, level + 1));
	//     }
	//     return result;
	// }

	private _logOut() {
		this._authService.logOut();
		this._router.navigate(["/"]);
	}
}
